import { ajax } from '../index'

/**
 * 四大板块Api
 */
export default {
  // 获取top5推荐商品
  mooncakeBox(topic: string) {
    return ajax.get('api', `/api/v1/mooncake/box?topic=${topic}`, {})
  },

  // 获取banner图
  getFullBanner(topic: string) {
    return ajax.get('api', `/api/v1/banner/full-banners?topic=${topic}`, {})
  },

  // 获取recommend分类
  getRecommendCategory(topic: string) {
    return ajax.get('api', `/api/v1/category/recommend/${topic}`, {})
  },

  // 获取左侧筛选分类
  getSidebarFilter(topic: string) {
    return ajax.get('api', `/api/v1/sidebar/filter/${topic}`, {})
  },

  // 获取各模块商品列表
  getSectionList(type: string, params: any) {
    return ajax.get('api', `/api/v1/product/list/${type}`, params)
  },

  // 获取各模块about
  getAboutDetail(type: string) {
    return ajax.get('api', `/api/v1/category/topic/${type}`, {})
  },

  // 获取new & hot 列表
  getNewHotList() {
    return ajax.get('api', `/api/v1/product/list/hot-new`, {})
  }
}